import { TrendingDown, MessageCircle, ShieldCheck, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const benefits = [
  { icon: TrendingDown, title: "Miglior tariffa disponibile", text: "Accesso alle condizioni più convenienti previste per la prenotazione diretta." },
  { icon: MessageCircle, title: "Contatto personale", text: "Comunicazione diretta prima, durante e dopo il soggiorno." },
  { icon: ShieldCheck, title: "Nessun passaggio inutile", text: "Conferma e assistenza gestite direttamente da Martelli Rentals." },
  { icon: Sparkles, title: "Maggiore flessibilità", text: "Possibilità di valutare richieste particolari, arrivi e servizi aggiuntivi." },
];

export default function DirectBooking() {
  return (
    <section className="py-24 md:py-32 bg-brand-olive text-brand-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Prenotazione diretta</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl">Prenota direttamente, con più semplicità.</h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 80}>
              <div className="border-t border-white/20 pt-6">
                <Icon className="w-7 h-7 text-brand-gold" />
                <h3 className="font-heading text-2xl mt-4">{title}</h3>
                <p className="text-white/70 text-sm mt-2 leading-relaxed">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-12 text-sm text-white/60 italic">Le condizioni possono variare in base alla struttura, alle date e alla tariffa selezionata.</p>
      </div>
    </section>
  );
}
